import { Box, Collapse, IconButton, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'

export default function AdminMessageBanner({ message, onDismiss }) {
  if (!message) return null
  return (
    <Collapse in unmountOnExit>
      <Box sx={{ px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'background.default' }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            px: 2.5,
            py: 1.5,
            bgcolor: (theme) => theme.palette.mode === 'dark' ? '#2D1A00' : '#FFF8F1',
            border: '1px solid',
            borderColor: (theme) => theme.palette.mode === 'dark' ? '#7A3D00' : '#FFD199',
            borderRadius: 2,
          }}
        >
          <Box
            sx={{
              width: 44,
              height: 44,
              borderRadius: '50%',
              bgcolor: (theme) => theme.palette.mode === 'dark' ? '#3D2200' : '#FFE5C8',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
            }}
          >
            <WarningAmberIcon sx={{ color: '#F59E0B', fontSize: 22 }} />
          </Box>

          <Typography
            component="div"
            sx={{
              flex: 1,
              minWidth: 0,
              fontSize: 13,
              lineHeight: 1.7,
              color: 'text.primary',
              '& strong': { fontWeight: 700 },
              '& em':     { fontStyle: 'italic' },
              '& ul, & ol': { pl: 2.5, my: 0.25 },
              '& li': { mb: 0.25 },
            }}
            dangerouslySetInnerHTML={{ __html: message.content }}
          />

          <IconButton
            size="small"
            onClick={onDismiss}
            sx={{
              color: 'text.secondary',
              flexShrink: 0,
              '&:hover': { bgcolor: (theme) => theme.palette.mode === 'dark' ? '#3D2200' : '#FFE5C8' },
            }}
          >
            <CloseIcon sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      </Box>
    </Collapse>
  )
}
